import { FileIconComponent } from './FileIcon.component';

export const FileIcon = FileIconComponent;
